import { jsx as _jsx } from "react/jsx-runtime";
export const Stats = ({ children, className = "" }) => {
    return (_jsx("div", { className: `grid gap-4 ${className}`, style: {
            gridTemplateColumns: `repeat(auto-fit, minmax(250px, 1fr))`,
        }, children: children }));
};
export default Stats;
